import { sendGoogleEvent } from '@html/_common/utils';

export default function AOClpSeoDeals() {
  const DEALS_WRAPPER_CLASS_JS = '.js-ao-clp-seo-deals';
  const DEALS_PERCENTAGE_AMOUNT_CLASS_JS = '.js-ao-clp-seo-deals__percentage-text--amount';
  const DEALS_CONTINENT_CLASS_JS = '.js-ao-clp-seo-deals__continent';

  let $dealsContinents = null;
  let $dealsPercentWrapper = null;
  let worldwideDeal = null;
  let animationDealInterval = null;

  this.initiate = () => {
    const noDealsBlockOnPage = $(DEALS_WRAPPER_CLASS_JS).length === 0;
    if (noDealsBlockOnPage) {
      return;
    }

    $dealsPercentWrapper = $(DEALS_PERCENTAGE_AMOUNT_CLASS_JS);
    $dealsContinents = $(DEALS_CONTINENT_CLASS_JS);
    worldwideDeal = parseInt($dealsPercentWrapper.text(), 10) || 0;

    $dealsContinents.mouseenter((event) => {
      const $hoveredContinent = $(event.currentTarget);
      const targetPercent = parseInt($hoveredContinent.data('deal-percentage'), 10) || 0;

      const $startingElement = $(event.relatedTarget);
      const startingPercent = $startingElement.hasClass('ao-clp-seo-deals__continent') ? parseInt($startingElement.data('deal-percentage'), 10) : worldwideDeal;

      this.animatePercentageChange(startingPercent, targetPercent);
    }).mouseleave((event) => {
      const $targetElement = $(event.relatedTarget);
      if ($targetElement.hasClass('ao-clp-seo-deals__continent')) {
        return;
      }

      const $currentElement = $(event.currentTarget);
      const startingPercent = parseInt($currentElement.data('deal-percentage'), 10);

      this.animatePercentageChange(startingPercent, worldwideDeal);
    });

    this.initiateTracking();
  };

  this.animatePercentageChange = (startPercent, targetPercent) => {
    clearInterval(animationDealInterval);
    let iteratePercent = startPercent;

    animationDealInterval = setInterval(() => {
      if (iteratePercent === targetPercent) {
        clearInterval(animationDealInterval);
        return;
      }

      iteratePercent = (startPercent < targetPercent) ? iteratePercent + 1 : iteratePercent - 1;
      $dealsPercentWrapper.text(iteratePercent);
    }, 10);
  };

  this.initiateTracking = () => {
    const continentCategory = 'Deals SEO - The Best Deals Worldwide';
    const $allDealsContinent = $('.js-ao-clp-seo-deals__continent');

    $allDealsContinent.on('click', (event) => {
      const $clickedElement = $(event.currentTarget);
      const clickedElementLink = $clickedElement.attr('href');

      if (typeof clickedElementLink === typeof undefined || clickedElementLink === false) {
        return;
      }

      sendGoogleEvent(
        continentCategory,
        clickedElementLink,
        `Item: ${$clickedElement.index() + 1}`,
      );
    });

    $('.js-ao-clp-seo-deals__see-all').on('click', (event) => {
      const $clickedElement = $(event.currentTarget);
      const clickedElementLink = $clickedElement.attr('href');

      if (typeof clickedElementLink === typeof undefined || clickedElementLink === false) {
        return;
      }

      sendGoogleEvent(
        continentCategory,
        clickedElementLink,
        'CTA - See All Deals',
      );
    });
  };
}
